export default function filterCatalogProducts(query, products = []) {
  const filterQuery = String(query || '').trim().toLowerCase();
  if (!filterQuery) return products;

  return products.filter((product) => [
    product.product,
    product.name,
    product.vendor,
    product.vendorCode,
    product.id,
  ].some(value => String(value || '').toLowerCase().includes(filterQuery)));
}
